export function getCurrentDomain(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Fallback for server-side rendering or when window is not available
  return 'https://forkast.in';
}

export function getCurrentUrl(path?: string): string {
  const domain = getCurrentDomain();
  if (path) {
    return `${domain}${path.startsWith('/') ? path : `/${path}`}`;
  }
  
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
  
  return domain;
}

export function getImageUrl(imagePath: string): string {
  if (imagePath.startsWith('http')) {
    return imagePath;
  }
  
  const domain = getCurrentDomain();
  return `${domain}${imagePath.startsWith('/') ? imagePath : `/${imagePath}`}`;
}